import { Text } from '@vinted/web-ui'

export type Props = {
  discountHint?: string
}

const BundleHeaderSubtitle = ({ discountHint }: Props) => (
  <Text
    as="h3"
    type={Text.Type.Subtitle}
    format
    text={discountHint}
    theme="success"
    width={Text.Width.Parent}
    alignment={Text.Alignment.Center}
    testId="bundle-header-title"
  />
)

export default BundleHeaderSubtitle
